module.exports = __webpack_public_path__ + "media/images/emoticons/shadow-aa37cb0fd04f79824b3f85f88b2c34a8.gif";